// extracted by mini-css-extract-plugin
module.exports = {"stickyFooter":"StickyFooter_stickyFooter__33Zd3","fullWidth":"StickyFooter_fullWidth__1Gvkh"};